import { Link } from "react-router-dom";
import { PHOTOS } from "../data/content";
import PageHero from "../components/PageHero";

export default function NotFound() {
  return (
    <main data-testid="not-found-page">
      <PageHero image={PHOTOS.lakeSunset} eyebrow="404" title="This page drifted off." subtitle="We couldn't find what you were looking for." />
      <section className="py-20 bg-[var(--ec-cream)]">
        <div className="max-w-3xl mx-auto px-5 lg:px-10 flex flex-wrap gap-3">
          <Link to="/" data-testid="not-found-home-link" className="inline-flex items-center bg-[var(--ec-navy)] text-white hover:bg-[var(--ec-lake)] font-semibold px-7 py-4 rounded-full btn-lift">
            Back to Home
          </Link>
          <Link to="/contact" data-testid="not-found-contact-link" className="inline-flex items-center border border-[var(--ec-navy)] text-[var(--ec-navy)] hover:bg-[var(--ec-navy)] hover:text-white font-semibold px-7 py-4 rounded-full btn-lift">
            Contact Us
          </Link>
        </div>
      </section>
    </main>
  );
}
